import { render, staticRenderFns } from "./SearchFormItem.vue?vue&type=template&id=5231485a&"
import script from "./SearchFormItem.vue?vue&type=script&lang=js&"
export * from "./SearchFormItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchFormItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports